import { useState } from 'react';

/**
 * Заглушка для связывания диаграмм — backend endpoints для link/unlink по meta-registry entries
 * пока не реализованы. Диаграммы отображаются в режиме read-only через GET /entries/:id/diagrams.
 */
export const useDiagramLinking = () => {
  const [linking] = useState(false);
  const [linkError] = useState('');
  const [selectedDiagramId, setSelectedDiagramId] = useState('');

  const handleLinkDiagram = async () => {};
  const handleUnlinkDiagram = async () => {};

  return {
    linking,
    linkError,
    selectedDiagramId,
    setSelectedDiagramId,
    handleLinkDiagram,
    handleUnlinkDiagram
  };
};
